module.exports = __webpack_public_path__ + "static/media/Notifications.1bc41c05.svg";